import { Link } from "react-router-dom";
import classes from "./ErrorPage.module.css";

export default function ErrorPage() {
  return (
    <section className={classes.errorPage} aria-labelledby="error-title">
      <div className={classes.card}>
        <h1 id="error-title">Page not found</h1>
        <p className={classes.message}>
          The page you&apos;re looking for doesn&apos;t exist or may have moved.
        </p>
        <Link to="/" className={classes.homeLink}>
          Return home
        </Link>
      </div>
    </section>
  );
}
